import React from 'react';
import classNames from 'classnames';
import {useTranslation} from '../../../../config/TranslationProvider';

const radiusValues = [
    '100m',
    '500m',
    '1km',
    '2km',
    '5km',
    '10km',
];

const RadiusSelector = ({radius, setRadius}) => {
    const ariaLabelPrefix = useTranslation('in_range_of');
    return (
        <div className="btn-group w-100" role="group">
            {radiusValues.map(value => (
                <button
                    key={value}
                    type="button"
                    className={classNames({
                        'btn btn-gradient btn-xs': true,
                        'active': value === radius,
                    })}
                    onClick={e => {
                        e.currentTarget.blur();

                        setRadius(value);
                    }}
                    aria-label={ariaLabelPrefix + ' ' + value}
                >
                    {value}
                </button>
            ))}
        </div>
    );
};

export default RadiusSelector;
